/*
 * @Author: Merlin
 * @Date: 2024-03-11 14:16:26
 * @LastEditors: Merlin
 * @LastEditTime: 2024-04-26 16:24:40
 * @Description:
 */


// ↓ 发起请求的几种类型 
export enum Action {
    Bet = 0,
    Hit = 1,
    Stand = 2,
    Double = 3,
    Split = 4,
    Insurance = 5,
}

// ↓ 保存卡片信息的变量名 
export enum CardsBox {
    handsBot = 'handsBot',
    handsUser1 = 'handsUser1',
    handsUser2 = 'handsUser2',
}

export interface AddCardTask {
    sTarget: CardsBox;
    oParams: CardInterface;
}
// export interface AddCardTaskList {
//     sTarget: CardsBox;
//     oParams: CardInterface;
// }

export enum BetType {
    StartBet = 0,
    HandsStart = 1,
    HandsStop = 2,
}

// ↓ 这是转子组件的卡牌数组的成员类型 
export interface CardInterface {
    cardID: string; // '8-c' 
    goFast?: boolean, // 使卡片直接出现在目标位置，不显示移动过程 
    exposed?: boolean; // 使卡片直接显示正面，不显示翻转动画 

    isOpen?: boolean; // 似乎也没用 
    needFlip?: boolean; // true 为明牌, false 是扣下的牌，（实际没啥用，因为通过 cardid == card_close 能辨别）
    onStart?: boolean; // 
    isSplitCard?: boolean; // 
    isRoundStartCard?: boolean; // 
    isLastCard?: boolean; // 页面重载是会用到，表示是最后一张牌，需要动画 
}

// ↓接口返回状态值
export type gameStatus = '' | 'cashout' | 'lose' | 'play';
// ↓前端游戏状态值 
export type userStatus = gameStatus | 'locked' | 'await' | 'split' | 'win' | 'equal' | 'bust';

export interface HandCards4Dealer{
    cards: string[];
    points: number;
}
export interface HandCards4User extends HandCards4Dealer{
    amount: number;
    winAmount: number;
    type: number;
};

// ↓ 这是后台返回的下注信息
export interface RoundDataInterface {
    _id?: number,
    firstHand: HandCards4User;
    secondHand: HandCards4User;
    dealerHand: HandCards4Dealer;
    status: gameStatus;
    currency: string; // cny, usd, btc... 
    multi: number; // 赢钱倍数
    winAmount: number; // 赢钱金额
    initialBetAmount: number; // 下注金额1：本金
    insuranceAmount?: number; // 下注金额2：保险，可能是0或某个其它数值，或不存在 
    reload_?: boolean;  // 前端追加属性，为 true 时表示正在刷新重载  
    // ===== ↓ Pro 模式专用 ==========================================
    pairsBetAmount?: number; // ←下注金额
    pairsWinAmount?: number; // ←赢钱金额
    tripleBetAmount?: number; // ←下注金额
    tripleWinAmount?: number; // ←赢钱金额
}


// ↓ 开局 ❤️
// 4235["games.blackjack.bet",{"amount":"10.00000000","type":0,"frontID":1712911941357}]
// ↓ Hit ❤️
// 4236["games.blackjack.bet",{"amount":"10.00000000","type":1,"frontID":1712911955731}]	
// ↓ Stand ❤️
// 4238["games.blackjack.bet",{"amount":"10.00000000","type":2,"frontID":1712912139823}]	
// ↓ Double ❤️
// 4240["games.blackjack.bet",{"amount":"10.00000000","type":3,"frontID":1712912166250}]	
// ↓ 买 ❤️ 不买保险 
// 4261["games.blackjack.bet",{"amount":"10.00000000","type":5,"isAccept":true,"frontID":1712912281654}]	
// 4233["games.blackjack.bet",{"amount":"10.00000000","type":5,"isAccept":false,"isBonusBet":true,"frontID":1712911898000}]	
// ------------------------------------------------------
// ↓ pro 模式 ❤️  
// 4228["games.blackjack.bet",{"amount":"10.00000000","type":0,"pairsAmount":11,"tripleAmount":12,"frontID":1713935543527}]	
// ↓ pro 模式开局后的操作没有多余的属性： pairsAmount, tripleAmount 
// 4229["games.blackjack.bet",{"amount":"10.00000000","type":1,"frontID":1713935656089}]	

// ↓ Pro 模式专用
export interface ProModeInfo {
    pairsAmount?: number; // 完美对子赌金
    tripleAmount?: number; // 21 + 3 赌金
};

// ↓ 提交请求的的入参 
export interface ParamsPart extends ProModeInfo{
    type: Action;
    isAccept?: boolean;
    isBonusBet?: boolean;
}

// ↓ 提交请求的的入参 
export interface Params2Submit extends ParamsPart {
    amount: number;
    frontID: number;
}


// ↓ 将字符转数字 （纯函数）
export const string2Number = (sDardID='')=>{
    const [sFirst, sSecond] = sDardID.split('-');
    // ↓ 没有第2位，说明字符串不包含 - 那么此时返回 0
    if (!sSecond) return 0; 
    if (sFirst === 'A') { // ←始终统计为1，由外部按需转为 11 
        return 1;
    } else if (['10', 'J', 'Q', 'K'].includes(sFirst)) {
        return 10;
    } else if ('123456789'.includes(sFirst)) {
        return Number(sFirst);
    }
    return 0;
}

// ↓ 检查是否玩家的牌都爆了 
// ↓ 如果都爆了，则不显示庄家第2张牌 
export const checkIfExploded = (oRound)=>{ 
    if (oRound && oRound.firstHand){ 
        return (
            oRound.firstHand.points > 21 
            &&
            (!oRound.secondHand || oRound.secondHand.points > 21)
        );
    }
    return false;
}


export const oMethods = {
    getList() {
        return [Action.Hit, Action.Stand, Action.Split, Action.Double];
    },

    // ↓ 计算点数
    getPoints(aHands, iAceCardAs = 11) {
        // console.log("计算分数 getPoints()", deepCopy(aHands)); 
        let points = 0; // ← 最终结果值
        let hasAce = false; // ← 功用： 如果有多个A，只有第1个可以记分为 11 
        aHands.forEach((oCard) => {
            // ↓ 此处 oCard.cardID 可能的值有：'A-d', '8-d', '10-d', 'closed_card', .....
            let thisPoint = string2Number(oCard.cardID);
            const isThisA = oCard.cardID.startsWith('A-');
            if (isThisA && iAceCardAs === 11 && !hasAce) {
                hasAce = true; // 立即设为 true 防止再次进入这个 if 
                thisPoint = 11;
            }
            points += thisPoint;
        });
        return points;
    },
    // ↓ 计算得分的2种可能的结果 
    getTotalPoints(hand) {
        // console.log("getTotalPoints\n", deepCopy(hand)); 
        let highPoints = this.getPoints(hand); 
        let lowPoints = this.getPoints(hand, 1); 
        // -- ↑ 2种记分方案 ------------------------------------------ 
        if (lowPoints === highPoints) {
            lowPoints = 0;
        } else if ([lowPoints, highPoints].includes(21)) {
            highPoints = 21;
            lowPoints = 0;
        } else {
            const isHighBust = highPoints > 21;
            const isLowBust = lowPoints > 21;
            if (isLowBust && isHighBust) { 
                lowPoints = Math.min(lowPoints, highPoints);
                highPoints = 0;
            } 
            if (!isHighBust && isLowBust) { // ←判断永远无法通过吧
                if (import.meta.dev) debugger; 
                highPoints = 0;
            }
            if (isHighBust && !isLowBust) {
                highPoints = lowPoints;
                lowPoints = 0;
            }
        }
        const arr = [highPoints, lowPoints];
        // ↓ 防止无效值在首位（因为外部在首选此方法返回值的首位） 
        if (arr[0] === 0) arr.reverse(); 
        return arr;
    },
    // ↓原版
    getTotalPoints__原版代码仅用于参考(t) {
        let s = this.getPoints(t), // s = heigh
        e = this.getPoints(t, 1); // e = low
        if (s === e)
            e = 0;
        else if ([s, e].includes(21))
            s = 21,
            e = 0;
        else {
            const i = s > 21,
            a = e > 21;
            i && a && (
                s = s < e ? s : e,
                e = 0
            ),
            // ↓ high 没超限 && low 值超了限(不合逻辑)，那么： high 值归零  ???????????????????
            !i && a && ( s = 0 ),
            // ↓ high 已经超限 && low 值没超限，那么： high 值取自 low 值，low 值归零 
            i && !a && ( s = e, e = 0 ) 
        }
        return [s, e]
    },
};

